// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "html,body,.profile-container,.wrong-page{height:100%}.wrong-page .title-header{color:#009be5}", ""]);
// Exports
module.exports = exports;
